// Den Excel-Report von K2 im Büro anhängen (E3c, S3; Prüfung des Plans E3c,
// Befund 11) – die Unterkonstruktionsliste, die mit der Bestellung an den
// Lieferanten geht. Wie das K2-PDF (../dachplanung.ts): hier vorher prüfen,
// was der Server ohnehin prüft (nur .xlsx, nicht leer, höchstens 10 MB, der
// Inhalt eine Arbeitsmappe) – damit eine falsche Datei gleich am Knopf eine
// klare Meldung bekommt; dann hochladen (PUT /api/crm/datei/:pruefsumme) und
// an die Anlage hängen (PATCH, `k2Excel`). Die HE-Doku legt ihn ab S5 selbst ab.

import { DATEI_ARTEN, dateiInhaltPruefen, XLSX, type BueroAntwort } from "@happy-energy/kern";
import { aendern, dateiSenden } from "@happy-energy/oberflaeche";
import { pruefsummeVon } from "../dachplanung.ts";

/** Die größte Datei, die der Server als Excel-Report annimmt. */
export const XLSX_GROESSTE = DATEI_ARTEN[XLSX];

/** Passt die gewählte Datei? null: ja; sonst, was nicht passt, in einem Satz. */
export function xlsxPruefen(datei: { type: string; size: number; name: string }): string | null {
  const istXlsx = datei.type === XLSX || /\.xlsx$/i.test(datei.name);
  if (!istXlsx) return "Das geht nur mit dem Excel-Report von K2 als .xlsx (nicht .xls oder .csv).";
  if (datei.size === 0) return "Die Datei ist leer.";
  if (datei.size > XLSX_GROESSTE) return `Die Datei ist zu groß – höchstens ${Math.round(XLSX_GROESSTE / (1024 * 1024))} MB.`;
  return null;
}

/** Den Excel-Report an die Anlage hängen: prüfen, hochladen, anhängen. Wirft mit einer Meldung für Menschen, wenn die Datei nicht passt. */
export async function k2ExcelAnhaengen(anlageId: string, datei: File): Promise<void> {
  const fehler = xlsxPruefen(datei);
  if (fehler) throw new Error(fehler);
  const daten = await datei.arrayBuffer();
  if (dateiInhaltPruefen(XLSX, new Uint8Array(daten)) !== null) throw new Error("Diese Datei ist kein Excel-Report (.xlsx).");
  const pruefsumme = await pruefsummeVon(daten);
  await dateiSenden(`/api/crm/datei/${pruefsumme}`, new Blob([daten], { type: XLSX }));
  await aendern<BueroAntwort>(`/api/crm/anlage/${anlageId}`, { k2Excel: { pruefsumme } });
}
